import { Image } from '@belong/ui';
import classNames from 'classnames/bind';
import styles from './current-home-marker.module.css';

type CurrentHomeMarkerProps = {
  isHover: boolean;
  home: any;
  /**
   * `lat`/`lng` are read off this element by `google-map-react` itself to
   * position the marker, so they are part of the contract even though this
   * component never reads them. `isActive` is likewise passed by the map.
   */
  lat: number;
  lng: number;
  isActive: boolean;
};

const cx = classNames.bind(styles);
const selectedMarkerSrc =
  'https://belong-consumer-assets.s3.us-west-1.amazonaws.com/accounts/map_home_pin_v2.svg';
const markerSrc =
  'https://belong-consumer-assets.s3.us-west-1.amazonaws.com/accounts/map_home_pin_v2.svg';

export function CurrentHomeMarker({ isHover }: CurrentHomeMarkerProps) {
  return (
    <div>
      <div className={cx('current-home-marker', { hover: isHover })}>
        <Image
          src={isHover ? selectedMarkerSrc : markerSrc}
          className={cx('listing-icon')}
          alt=""
        />
      </div>
    </div>
  );
}
